var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0002 7.98276C22.0004 7.99387 22.0004 8.00498 22.0002 8.01606V16.25C22.0002 18.3211 20.3213 20 18.2502 20H5.75016C3.67909 20 2.00016 18.3211 2.00016 16.25V8.01504C1.99995 8.00464 1.99995 7.99422 2.00016 7.98378V7.75C2.00016 5.67893 3.67909 4 5.75016 4H18.2502C20.3213 4 22.0002 5.67893 22.0002 7.75V7.98276ZM20.5002 9.21772L13.6876 12.6503C12.6262 13.1851 11.3742 13.1851 10.3128 12.6503L3.50016 9.21772V16.25C3.50016 17.4926 4.50752 18.5 5.75016 18.5H18.2502C19.4928 18.5 20.5002 17.4926 20.5002 16.25V9.21772ZM20.4908 7.54281L13.0126 11.3108C12.3758 11.6316 11.6246 11.6316 10.9878 11.3108L3.50958 7.54282C3.61416 6.39729 4.57737 5.5 5.75016 5.5H18.2502C19.4229 5.5 20.3862 6.39729 20.4908 7.54281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email-2.5d058f50ac2cbb454d593a9adf64c0b6.svg";
export { ForwardRef as ReactComponent };